package fr.manyverse.app.infrastructure.di

import fr.manyverse.app.AppConfig
import fr.manyverse.app.OAuthCallback
import fr.manyverse.app.domain.model.Universe
import fr.manyverse.app.domain.image.ImageOptimizer
import fr.manyverse.app.domain.repository.AuthRepository
import fr.manyverse.app.domain.repository.CharacterCacheRepository
import fr.manyverse.app.domain.repository.CharacterRepository
import fr.manyverse.app.domain.repository.DigicodeRepository
import fr.manyverse.app.domain.repository.GameEventCacheRepository
import fr.manyverse.app.domain.repository.GameEventRepository
import fr.manyverse.app.domain.repository.UserFeedbackRepository
import fr.manyverse.app.domain.repository.GameTableRepository
import fr.manyverse.app.domain.repository.GmInventoryRepository
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.repository.InventoryRepository
import fr.manyverse.app.domain.repository.LockpickingRepository
import fr.manyverse.app.domain.repository.PreMadeCharacterRepository
import fr.manyverse.app.domain.repository.SignedUrlCacheRepository
import fr.manyverse.app.domain.repository.SoundRepository
import fr.manyverse.app.domain.repository.RealtimeConnectionRepository
import fr.manyverse.app.domain.repository.TimerRepository
import fr.manyverse.app.domain.repository.UniverseRepository
import fr.manyverse.app.domain.repository.UserConfigRepository
import fr.manyverse.app.domain.repository.WhiteboardRepository
import fr.manyverse.app.domain.repository.CombatRepository
import fr.manyverse.app.domain.usecase.CancelDigicodeUseCase
import fr.manyverse.app.domain.usecase.CancelLockpickingUseCase
import fr.manyverse.app.domain.usecase.CheckCharacterInActiveTableUseCase
import fr.manyverse.app.domain.usecase.ClearCharacterCacheUseCase
import fr.manyverse.app.domain.usecase.ClearWhiteboardUseCase
import fr.manyverse.app.domain.usecase.CloseDigicodeUseCase
import fr.manyverse.app.domain.usecase.CloseLockpickingUseCase
import fr.manyverse.app.domain.usecase.CloseWhiteboardForAllUseCase
import fr.manyverse.app.domain.usecase.CopyPreMadeToCharacterUseCase
import fr.manyverse.app.domain.usecase.CountCharactersInUniverseUseCase
import fr.manyverse.app.domain.usecase.CountCharactersUseCase
import fr.manyverse.app.domain.usecase.CountPreMadeCharactersUseCase
import fr.manyverse.app.domain.usecase.CancelAnnouncementUseCase
import fr.manyverse.app.domain.usecase.CreateAnnouncementUseCase
import fr.manyverse.app.domain.usecase.CreateCharacterUseCase
import fr.manyverse.app.domain.usecase.CreateDiceRollEventUseCase
import fr.manyverse.app.domain.usecase.CreateDigicodeUseCase
import fr.manyverse.app.domain.usecase.CreateGameTableUseCase
import fr.manyverse.app.domain.usecase.CreateGmInventoryItemUseCase
import fr.manyverse.app.domain.usecase.CreateInventoryItemUseCase
import fr.manyverse.app.domain.usecase.CreateLockpickingUseCase
import fr.manyverse.app.domain.usecase.CreatePreMadeCharacterUseCase
import fr.manyverse.app.domain.usecase.CreateTimerUseCase
import fr.manyverse.app.domain.usecase.DeleteAccountUseCase
import fr.manyverse.app.domain.usecase.DeleteCharacterImageUseCase
import fr.manyverse.app.domain.usecase.DeleteCharacterUseCase
import fr.manyverse.app.domain.usecase.DeleteGameTableUseCase
import fr.manyverse.app.domain.usecase.UpdateGameTableNameUseCase
import fr.manyverse.app.domain.usecase.DeleteGmInventoryItemImageUseCase
import fr.manyverse.app.domain.usecase.DeleteGmInventoryItemUseCase
import fr.manyverse.app.domain.usecase.DeleteInventoryItemImageUseCase
import fr.manyverse.app.domain.usecase.DeleteInventoryItemUseCase
import fr.manyverse.app.domain.usecase.DeletePreMadeCharacterImageUseCase
import fr.manyverse.app.domain.usecase.DeletePreMadeCharacterUseCase
import fr.manyverse.app.domain.usecase.DeleteSoundUseCase
import fr.manyverse.app.domain.usecase.DrawOnWhiteboardUseCase
import fr.manyverse.app.domain.usecase.GetActiveWhiteboardUseCase
import fr.manyverse.app.domain.usecase.GetWhiteboardActionsUseCase
import fr.manyverse.app.domain.usecase.GetAllCharactersUseCase
import fr.manyverse.app.domain.usecase.GetAllUserActiveTablesUseCase
import fr.manyverse.app.domain.usecase.GetCharacterByIdUseCase
import fr.manyverse.app.domain.usecase.GetCharactersUseCase
import fr.manyverse.app.domain.usecase.GetCurrentUserUseCase
import fr.manyverse.app.domain.usecase.GetGmInventoryItemsUseCase
import fr.manyverse.app.domain.usecase.GetInventoryItemsUseCase
import fr.manyverse.app.domain.usecase.GetPreMadeCharacterByIdUseCase
import fr.manyverse.app.domain.usecase.GetPreMadeCharactersUseCase
import fr.manyverse.app.domain.usecase.GetTableByIdUseCase
import fr.manyverse.app.domain.usecase.GetTableEventsUseCase
import fr.manyverse.app.domain.usecase.CreateUniverseUseCase
import fr.manyverse.app.domain.usecase.DeleteUniverseUseCase
import fr.manyverse.app.domain.usecase.GetUniversesUseCase
import fr.manyverse.app.domain.usecase.UpdateUniverseUseCase
import fr.manyverse.app.domain.usecase.GetUserSoundsUseCase
import fr.manyverse.app.domain.usecase.JoinGameTableUseCase
import fr.manyverse.app.domain.usecase.KickPlayerUseCase
import fr.manyverse.app.domain.usecase.LeaveTableUseCase
import fr.manyverse.app.domain.usecase.NotifyItemSentUseCase
import fr.manyverse.app.domain.usecase.NotifyPlayerJoinedUseCase
import fr.manyverse.app.domain.usecase.ObserveActiveAnnouncementsUseCase
import fr.manyverse.app.domain.usecase.GetActiveTimersUseCase
import fr.manyverse.app.domain.usecase.ObserveActiveTimersUseCase
import fr.manyverse.app.domain.usecase.PauseTimerUseCase
import fr.manyverse.app.domain.usecase.ObserveActiveWhiteboardUseCase
import fr.manyverse.app.domain.usecase.ObserveGameTableMembersUseCase
import fr.manyverse.app.domain.usecase.ObserveUserMembershipChangesUseCase
import fr.manyverse.app.domain.usecase.ObserveInventoryItemsUseCase
import fr.manyverse.app.domain.usecase.ObserveRealtimeReconnectionsUseCase
import fr.manyverse.app.domain.usecase.ObserveTableEventsUseCase
import fr.manyverse.app.domain.usecase.ObserveWhiteboardActionsUseCase
import fr.manyverse.app.domain.usecase.OpenWhiteboardUseCase
import fr.manyverse.app.domain.usecase.StartCombatUseCase
import fr.manyverse.app.domain.usecase.CombatNextTurnUseCase
import fr.manyverse.app.domain.usecase.UpdateCombatParticipantsUseCase
import fr.manyverse.app.domain.usecase.StopCombatUseCase
import fr.manyverse.app.domain.usecase.ObserveActiveCombatUseCase
import fr.manyverse.app.domain.usecase.GetActiveCombatUseCase
import fr.manyverse.app.domain.usecase.GetTableMemberNotesUseCase
import fr.manyverse.app.domain.usecase.ResumeTimerUseCase
import fr.manyverse.app.domain.usecase.SaveTableMemberNotesUseCase
import fr.manyverse.app.domain.usecase.SendGmInventoryItemToPlayersUseCase
import fr.manyverse.app.domain.usecase.SendMessageUseCase
import fr.manyverse.app.domain.usecase.SendOtpUseCase
import fr.manyverse.app.domain.usecase.SendGmAlertUseCase
import fr.manyverse.app.domain.usecase.SendPlayerAlertUseCase
import fr.manyverse.app.domain.usecase.SendUserFeedbackUseCase
import fr.manyverse.app.domain.usecase.SetTableMemberCharacterUseCase
import fr.manyverse.app.domain.usecase.SignInAnonymouslyUseCase
import fr.manyverse.app.domain.usecase.SignInWithOAuthUseCase
import fr.manyverse.app.domain.usecase.SignOutUseCase
import fr.manyverse.app.domain.usecase.StopTimerUseCase
import fr.manyverse.app.domain.usecase.SubmitDigicodeAttemptUseCase
import fr.manyverse.app.domain.usecase.TimeoutDigicodeUseCase
import fr.manyverse.app.domain.usecase.TimeoutLockpickingUseCase
import fr.manyverse.app.domain.usecase.ToggleWhiteboardGridUseCase
import fr.manyverse.app.domain.usecase.TouchMemberCharacterUseCase
import fr.manyverse.app.domain.usecase.TransferInventoryItemUseCase
import fr.manyverse.app.domain.usecase.UnlockLockUseCase
import fr.manyverse.app.domain.usecase.UpdateCharacterSheetUseCase
import fr.manyverse.app.domain.usecase.UpdateCharacterUseCase
import fr.manyverse.app.domain.usecase.UpdateGmInventoryItemUseCase
import fr.manyverse.app.domain.usecase.UpdateInventoryItemQuantityUseCase
import fr.manyverse.app.domain.usecase.UpdatePreMadeCharacterUseCase
import fr.manyverse.app.domain.usecase.UploadCharacterImageUseCase
import fr.manyverse.app.domain.usecase.UploadGmInventoryItemImageUseCase
import fr.manyverse.app.domain.usecase.UploadInventoryItemImageUseCase
import fr.manyverse.app.domain.usecase.UploadPreMadeCharacterImageUseCase
import fr.manyverse.app.domain.usecase.UploadPreMadeInventoryItemImageUseCase
import fr.manyverse.app.domain.usecase.UploadSoundUseCase
import fr.manyverse.app.domain.usecase.VerifyOtpUseCase
import fr.manyverse.app.domain.usecase.userconfig.AcceptTermsUseCase
import fr.manyverse.app.domain.usecase.userconfig.CheckTermsAcceptanceUseCase
import fr.manyverse.app.infrastructure.audio.AudioPlayer
import fr.manyverse.app.infrastructure.audio.CrossfadeAudioPlayer
import fr.manyverse.app.infrastructure.audio.createAudioPlayer
import fr.manyverse.app.infrastructure.audio.startAudioBackgroundSupport
import fr.manyverse.app.infrastructure.auth.OAuthCallbackFailures
import fr.manyverse.app.infrastructure.cache.CharacterCache
import fr.manyverse.app.infrastructure.cache.GameEventCache
import fr.manyverse.app.infrastructure.cache.SignedUrlCache
import fr.manyverse.app.infrastructure.cache.UserConfigCache
import fr.manyverse.app.infrastructure.clipboard.ClipboardManager
import fr.manyverse.app.infrastructure.clipboard.createClipboardManager
import fr.manyverse.app.infrastructure.datastore.SoundMetadataDataStore
import fr.manyverse.app.infrastructure.datastore.UserPreferencesDataStore
import fr.manyverse.app.infrastructure.datastore.createSoundMetadataDataStore
import fr.manyverse.app.infrastructure.datastore.createUserPreferencesDataStore
import fr.manyverse.app.infrastructure.filestorage.LocalFileStorage
import fr.manyverse.app.infrastructure.filestorage.createLocalFileStorage
import fr.manyverse.app.infrastructure.image.createImageOptimizer
import fr.manyverse.app.infrastructure.monitoring.AppLoggerSupabaseProcessor
import fr.manyverse.app.infrastructure.monitoring.CrashReporter
import fr.manyverse.app.infrastructure.monitoring.CrashReportingUserBinder
import fr.manyverse.app.infrastructure.monitoring.currentCrashReporter
import fr.manyverse.app.infrastructure.realtime.GameRealtimeChannel
import fr.manyverse.app.infrastructure.repository.CachingCharacterRepository
import fr.manyverse.app.infrastructure.repository.CachingGameEventRepository
import fr.manyverse.app.infrastructure.repository.CachingImageStorageRepository
import fr.manyverse.app.infrastructure.repository.CachingUserConfigRepository
import fr.manyverse.app.infrastructure.repository.InMemorySoundRepository
import fr.manyverse.app.infrastructure.repository.LocalAudioStorageRepository
import fr.manyverse.app.infrastructure.repository.LocalSoundRepository
import fr.manyverse.app.infrastructure.repository.SupabaseAuthRepository
import fr.manyverse.app.infrastructure.repository.SupabaseCharacterRepository
import fr.manyverse.app.infrastructure.repository.SupabaseDigicodeRepository
import fr.manyverse.app.infrastructure.repository.SupabaseGameEventRepository
import fr.manyverse.app.infrastructure.repository.SupabaseUserFeedbackRepository
import fr.manyverse.app.infrastructure.repository.SupabaseGameTableRepository
import fr.manyverse.app.infrastructure.repository.SupabaseGmInventoryRepository
import fr.manyverse.app.infrastructure.repository.SupabaseImageStorageRepository
import fr.manyverse.app.infrastructure.repository.SupabaseInventoryRepository
import fr.manyverse.app.infrastructure.repository.SupabaseLockpickingRepository
import fr.manyverse.app.infrastructure.repository.SupabasePreMadeCharacterRepository
import fr.manyverse.app.infrastructure.repository.SupabaseRealtimeConnectionRepository
import fr.manyverse.app.infrastructure.repository.SupabaseTimerRepository
import fr.manyverse.app.infrastructure.repository.SupabaseUniverseRepository
import fr.manyverse.app.infrastructure.repository.SupabaseUserConfigRepository
import fr.manyverse.app.infrastructure.repository.SupabaseWhiteboardRepository
import fr.manyverse.app.infrastructure.repository.SupabaseCombatRepository
import fr.manyverse.app.infrastructure.serialization.appJson
import fr.manyverse.app.presentation.error.UserErrorNotifier
import fr.manyverse.app.presentation.viewmodel.ActiveGameViewModel
import fr.manyverse.app.presentation.viewmodel.AuthViewModel
import fr.manyverse.app.presentation.viewmodel.CharacterViewModel
import fr.manyverse.app.presentation.viewmodel.FeedbackViewModel
import fr.manyverse.app.presentation.viewmodel.DigicodeViewModel
import fr.manyverse.app.presentation.viewmodel.GameConfigurationViewModel
import fr.manyverse.app.presentation.viewmodel.GameMasterViewModel
import fr.manyverse.app.presentation.viewmodel.GmInventoryViewModel
import fr.manyverse.app.presentation.viewmodel.InventoryViewModel
import fr.manyverse.app.presentation.viewmodel.LockpickingViewModel
import fr.manyverse.app.presentation.viewmodel.PlayerNotesViewModel
import fr.manyverse.app.presentation.viewmodel.PlayerViewModel
import fr.manyverse.app.presentation.viewmodel.PreMadeCharactersViewModel
import fr.manyverse.app.presentation.viewmodel.SoundPlayerViewModel
import fr.manyverse.app.presentation.viewmodel.GmPlayerSheetViewModel
import fr.manyverse.app.presentation.viewmodel.TableCharacterViewModel
import fr.manyverse.app.presentation.viewmodel.TableJoiningViewModel
import fr.manyverse.app.presentation.viewmodel.DiceTrayViewModel
import fr.manyverse.app.presentation.viewmodel.ThemeViewModel
import fr.manyverse.app.presentation.viewmodel.TimerViewModel
import fr.manyverse.app.presentation.viewmodel.UniverseSelectionViewModel
import fr.manyverse.app.presentation.viewmodel.UniversesViewModel
import fr.manyverse.app.presentation.viewmodel.UserTablesViewModel
import fr.manyverse.app.presentation.viewmodel.WhiteboardViewModel
import fr.manyverse.app.presentation.viewmodel.CombatViewModel
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.Auth
import io.github.jan.supabase.auth.FlowType
import io.github.jan.supabase.createSupabaseClient
import io.github.jan.supabase.postgrest.Postgrest
import io.github.jan.supabase.realtime.Realtime
import io.github.jan.supabase.serializer.KotlinXSerializer
import io.github.jan.supabase.storage.Storage
import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.MutableStateFlow
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val appModule = module {
    // HTTP Client
    single {
        HttpClient {
            install(ContentNegotiation)
        }
    }

    // Supabase Client
    single<SupabaseClient> {
        // Validate configuration
        require(AppConfig.SUPABASE_URL.isNotBlank()) {
            "SUPABASE_URL not configured. Please set it in local.properties or environment variables."
        }
        require(AppConfig.SUPABASE_ANON_KEY.isNotBlank()) {
            "SUPABASE_ANON_KEY not configured. Please set it in local.properties or environment variables."
        }

        createSupabaseClient(
            supabaseUrl = AppConfig.SUPABASE_URL,
            supabaseKey = AppConfig.SUPABASE_ANON_KEY
        ) {
            // Fait remonter jusqu'à Sentry les erreurs que supabase-kt ne logge qu'en interne
            defaultLoggingFactory = ::AppLoggerSupabaseProcessor
            // Même configuration que le défaut de supabase-kt, sans recopier le JSON en échec dans
            // les exceptions (voir appJson) : réponses Postgrest et payloads Realtime compris
            defaultSerializer = KotlinXSerializer(appJson { ignoreUnknownKeys = true })
            install(Auth) {
                scheme = OAuthCallback.SCHEME
                host = OAuthCallback.HOST
                // PKCE plutôt que le flux implicite (défaut de supabase-kt) : le flux OAuth
                // passe par le navigateur système et revient sur un custom URL scheme, que
                // n'importe quelle app peut déclarer. En implicite, access_token ET
                // refresh_token transitent dans le fragment de l'URL de retour et seraient
                // interceptables ; en PKCE seul un code inutilisable sans le code verifier
                // (stocké localement) circule.
                flowType = FlowType.PKCE
                configurePlatformCallback()
                autoSaveToStorage = true
                autoLoadFromStorage = true
                // Keep session in memory and auto-refresh active when the app
                // is in background (Realtime, audio, timers depend on it).
                enableLifecycleCallbacks = false
            }
            install(Postgrest)
            install(Realtime)
            install(Storage)
        }
    }

    // User Preferences Storage
    single<UserPreferencesDataStore> { createUserPreferencesDataStore() }

    // Cache (implements CharacterCacheRepository)
    single { CharacterCache() }
    single<CharacterCacheRepository> { get<CharacterCache>() }

    // UserConfig Cache
    single { UserConfigCache() }

    // GameEvent Cache (cold-start cache for table events)
    single { GameEventCache() }
    single<GameEventCacheRepository> { get<GameEventCache>() }

    // Signed URL Cache
    single { SignedUrlCache() }
    single<SignedUrlCacheRepository> { get<SignedUrlCache>() }

    // Background scope for repository operations
    single<CoroutineScope> { CoroutineScope(SupervisorJob() + Dispatchers.Default) }

    // Crash reporting : démarré avant Koin par initMonitoring(), seulement exposé ici.
    // Le binder est créé au démarrage pour rattacher l'utilisateur dès la restauration de session.
    single<CrashReporter> { currentCrashReporter() }
    single(createdAtStart = true) { CrashReportingUserBinder(get(), get(), get()).apply { start() } }

    // Universe state flow (shared between ThemeViewModel and TablePrefixProvider)
    single { MutableStateFlow<Universe?>(null) }

    // Repositories
    single { OAuthCallbackFailures() }
    single<AuthRepository> { SupabaseAuthRepository(get(), get()) }
    // Use CachingCharacterRepository to wrap SupabaseCharacterRepository with transparent caching
    single { SupabaseCharacterRepository(get()) }
    single { CachingCharacterRepository(get<SupabaseCharacterRepository>(), get(), get()) }
    single<CharacterRepository> { get<CachingCharacterRepository>() }
    // Channel Realtime privé de l'utilisateur, partagé par tous les flux de partie
    single { GameRealtimeChannel(get(), get()) }
    single<GameTableRepository> { SupabaseGameTableRepository(get(), get()) }
    single { SupabaseGameEventRepository(get(), get()) }
    single { CachingGameEventRepository(get<SupabaseGameEventRepository>(), get(), get()) }
    single<GameEventRepository> { get<CachingGameEventRepository>() }

    single<UserFeedbackRepository> { SupabaseUserFeedbackRepository(get()) }
    single<WhiteboardRepository> { SupabaseWhiteboardRepository(get(), get()) }
    single<CombatRepository> { SupabaseCombatRepository(get(), get()) }
    single<TimerRepository> { SupabaseTimerRepository(get(), get()) }
    single<RealtimeConnectionRepository> { SupabaseRealtimeConnectionRepository(get()) }
    single<DigicodeRepository> { SupabaseDigicodeRepository(get(), get()) }
    single<LockpickingRepository> { SupabaseLockpickingRepository(get(), get()) }
    single<InventoryRepository> { SupabaseInventoryRepository(get(), get()) }
    single<GmInventoryRepository> { SupabaseGmInventoryRepository(get()) }
    single<PreMadeCharacterRepository> { SupabasePreMadeCharacterRepository(get()) }
    single<UniverseRepository> { SupabaseUniverseRepository(get()) }
    single { SupabaseUserConfigRepository(get()) }
    single { CachingUserConfigRepository(get(), get(), get()) }
    single<UserConfigRepository> { get<CachingUserConfigRepository>() }

    // Sound Repositories (local storage)
    single { InMemorySoundRepository() }
    single<LocalFileStorage> { createLocalFileStorage() }
    single<SoundMetadataDataStore> { createSoundMetadataDataStore() }
    single { LocalAudioStorageRepository(get()) }
    single { LocalSoundRepository(get<InMemorySoundRepository>(), get(), get()) }
    single<SoundRepository> { get<LocalSoundRepository>() }

    // Clipboard Manager
    single<ClipboardManager> { createClipboardManager() }

    // Audio Player
    single<AudioPlayer> { createAudioPlayer() }
    single {
        CrossfadeAudioPlayer(
            playerFactory = { createAudioPlayer() },
            scope = get()
        ).also { player ->
            startAudioBackgroundSupport(player, get())
        }
    }
    // Use CachingImageStorageRepository to wrap SupabaseImageStorageRepository with signed URL caching
    single { SupabaseImageStorageRepository(get()) }
    single { CachingImageStorageRepository(get<SupabaseImageStorageRepository>(), get()) }
    single<ImageStorageRepository> { get<CachingImageStorageRepository>() }

    // Image Optimizer (resize + WebP re-encode before upload)
    single<ImageOptimizer> { createImageOptimizer() }

    // Use Cases - UserConfig
    singleOf(::CheckTermsAcceptanceUseCase)
    singleOf(::AcceptTermsUseCase)

    // Use Cases - Auth
    singleOf(::SignOutUseCase)
    singleOf(::GetCurrentUserUseCase)
    singleOf(::DeleteAccountUseCase)
    singleOf(::SendOtpUseCase)
    singleOf(::VerifyOtpUseCase)
    singleOf(::SignInWithOAuthUseCase)
    singleOf(::SignInAnonymouslyUseCase)

    // Use Cases - Character
    singleOf(::GetCharactersUseCase)
    singleOf(::GetAllCharactersUseCase)
    singleOf(::CountCharactersUseCase)
    singleOf(::CountCharactersInUniverseUseCase)
    singleOf(::GetCharacterByIdUseCase)
    singleOf(::CreateCharacterUseCase)
    singleOf(::UpdateCharacterUseCase)
    singleOf(::UpdateCharacterSheetUseCase)
    single { DeleteCharacterUseCase(get(), get()) }
    singleOf(::ClearCharacterCacheUseCase)

    // Use Cases - Character Image
    singleOf(::UploadCharacterImageUseCase)
    singleOf(::DeleteCharacterImageUseCase)

    // Use Cases - Pre-made Characters
    singleOf(::GetPreMadeCharactersUseCase)
    singleOf(::CountPreMadeCharactersUseCase)
    singleOf(::GetPreMadeCharacterByIdUseCase)
    singleOf(::CreatePreMadeCharacterUseCase)
    singleOf(::UpdatePreMadeCharacterUseCase)
    single { DeletePreMadeCharacterUseCase(get(), get()) }
    singleOf(::UploadPreMadeCharacterImageUseCase)
    singleOf(::DeletePreMadeCharacterImageUseCase)
    singleOf(::UploadPreMadeInventoryItemImageUseCase)
    singleOf(::CopyPreMadeToCharacterUseCase)

    // Use Cases - Game Table
    singleOf(::CreateGameTableUseCase)
    singleOf(::JoinGameTableUseCase)
    singleOf(::SetTableMemberCharacterUseCase)
    singleOf(::TouchMemberCharacterUseCase)
    singleOf(::KickPlayerUseCase)
    singleOf(::DeleteGameTableUseCase)
    singleOf(::UpdateGameTableNameUseCase)
    singleOf(::LeaveTableUseCase)
    singleOf(::CheckCharacterInActiveTableUseCase)
    singleOf(::ObserveGameTableMembersUseCase)
    singleOf(::ObserveUserMembershipChangesUseCase)
    singleOf(::GetTableByIdUseCase)
    singleOf(::GetAllUserActiveTablesUseCase)
    singleOf(::SaveTableMemberNotesUseCase)
    singleOf(::GetTableMemberNotesUseCase)

    // Use Cases - Universe
    singleOf(::GetUniversesUseCase)
    singleOf(::CreateUniverseUseCase)
    singleOf(::UpdateUniverseUseCase)
    singleOf(::DeleteUniverseUseCase)

    // Use Cases - Sound
    singleOf(::UploadSoundUseCase)
    singleOf(::DeleteSoundUseCase)
    singleOf(::GetUserSoundsUseCase)

    // Use Cases - Game Events
    singleOf(::CreateAnnouncementUseCase)
    singleOf(::CancelAnnouncementUseCase)
    singleOf(::CreateDiceRollEventUseCase)
    singleOf(::GetTableEventsUseCase)
    singleOf(::ObserveActiveAnnouncementsUseCase)
    singleOf(::ObserveTableEventsUseCase)
    singleOf(::ObserveRealtimeReconnectionsUseCase)
    singleOf(::SendMessageUseCase)
    singleOf(::SendPlayerAlertUseCase)
    singleOf(::SendGmAlertUseCase)
    singleOf(::NotifyPlayerJoinedUseCase)
    singleOf(::NotifyItemSentUseCase)

    // Use Cases - Feedback
    singleOf(::SendUserFeedbackUseCase)

    // Use Cases - Timer
    singleOf(::CreateTimerUseCase)
    singleOf(::StopTimerUseCase)
    singleOf(::PauseTimerUseCase)
    singleOf(::ResumeTimerUseCase)
    singleOf(::ObserveActiveTimersUseCase)
    singleOf(::GetActiveTimersUseCase)

    // Use Cases - Digicode
    singleOf(::CreateDigicodeUseCase)
    singleOf(::SubmitDigicodeAttemptUseCase)
    singleOf(::CancelDigicodeUseCase)
    singleOf(::TimeoutDigicodeUseCase)
    singleOf(::CloseDigicodeUseCase)

    // Use Cases - Lockpicking
    singleOf(::CreateLockpickingUseCase)
    singleOf(::UnlockLockUseCase)
    singleOf(::CancelLockpickingUseCase)
    singleOf(::TimeoutLockpickingUseCase)
    singleOf(::CloseLockpickingUseCase)

    // Use Cases - GmInventory
    singleOf(::GetGmInventoryItemsUseCase)
    singleOf(::CreateGmInventoryItemUseCase)
    singleOf(::UpdateGmInventoryItemUseCase)
    singleOf(::DeleteGmInventoryItemUseCase)
    singleOf(::UploadGmInventoryItemImageUseCase)
    singleOf(::DeleteGmInventoryItemImageUseCase)
    singleOf(::SendGmInventoryItemToPlayersUseCase)

    // Use Cases - Inventory
    singleOf(::GetInventoryItemsUseCase)
    singleOf(::ObserveInventoryItemsUseCase)
    singleOf(::CreateInventoryItemUseCase)
    singleOf(::DeleteInventoryItemUseCase)
    singleOf(::UpdateInventoryItemQuantityUseCase)
    singleOf(::UploadInventoryItemImageUseCase)
    singleOf(::DeleteInventoryItemImageUseCase)
    singleOf(::TransferInventoryItemUseCase)

    // Use Cases - Whiteboard
    singleOf(::OpenWhiteboardUseCase)
    singleOf(::DrawOnWhiteboardUseCase)
    singleOf(::ClearWhiteboardUseCase)
    singleOf(::ToggleWhiteboardGridUseCase)
    singleOf(::CloseWhiteboardForAllUseCase)
    singleOf(::ObserveWhiteboardActionsUseCase)
    singleOf(::ObserveActiveWhiteboardUseCase)
    singleOf(::GetActiveWhiteboardUseCase)
    singleOf(::GetWhiteboardActionsUseCase)

    // Use Cases - Combat
    singleOf(::StartCombatUseCase)
    singleOf(::CombatNextTurnUseCase)
    singleOf(::UpdateCombatParticipantsUseCase)
    singleOf(::StopCombatUseCase)
    singleOf(::ObserveActiveCombatUseCase)
    singleOf(::GetActiveCombatUseCase)

    // Échecs d'actions sans état d'écran, affichés en snackbar
    single { UserErrorNotifier() }

    // ViewModels
    viewModelOf(::AuthViewModel)
    viewModelOf(::ThemeViewModel)
    viewModelOf(::DiceTrayViewModel)
    viewModelOf(::CharacterViewModel)

    // Game Table ViewModels
    viewModelOf(::TableJoiningViewModel)
    viewModelOf(::GameConfigurationViewModel)
    viewModelOf(::ActiveGameViewModel)
    viewModelOf(::WhiteboardViewModel)
    viewModelOf(::CombatViewModel)
    viewModelOf(::TimerViewModel)
    viewModelOf(::DigicodeViewModel)
    viewModelOf(::LockpickingViewModel)
    viewModelOf(::UserTablesViewModel)
    viewModelOf(::UniverseSelectionViewModel)
    viewModelOf(::UniversesViewModel)
    viewModelOf(::FeedbackViewModel)
    viewModel { params ->
        PlayerNotesViewModel(
            tableId = params.get(),
            userId = params.get(),
            getTableMemberNotesUseCase = get(),
            saveTableMemberNotesUseCase = get()
        )
    }
    viewModel { params ->
        TableCharacterViewModel(
            tableId = params.get(),
            userId = params.get(),
            universeId = params.get(),
            getCharactersUseCase = get(),
            createCharacterUseCase = get(),
            uploadCharacterImageUseCase = get(),
            updateCharacterUseCase = get(),
            getCharacterByIdUseCase = get(),
            setTableMemberCharacterUseCase = get(),
            touchMemberCharacterUseCase = get(),
            notifyPlayerJoinedUseCase = get(),
            getPreMadeCharactersUseCase = get(),
            copyPreMadeToCharacterUseCase = get(),
            updateCharacterSheetUseCase = get(),
            countCharactersInUniverseUseCase = get(),
            countPreMadeCharactersUseCase = get(),
            errorNotifier = get()
        )
    }
    viewModel { params ->
        GmInventoryViewModel(
            tableId = params.get(),
            gmUserId = params.get(),
            getGmInventoryItemsUseCase = get(),
            createGmInventoryItemUseCase = get(),
            updateGmInventoryItemUseCase = get(),
            deleteGmInventoryItemUseCase = get(),
            uploadGmInventoryItemImageUseCase = get(),
            deleteGmInventoryItemImageUseCase = get(),
            sendGmInventoryItemToPlayersUseCase = get(),
            notifyItemSentUseCase = get(),
            observeGameTableMembersUseCase = get(),
            getCharacterByIdUseCase = get(),
            imageStorageRepository = get(),
            errorNotifier = get()
        )
    }
    viewModel { params ->
        PreMadeCharactersViewModel(
            tableId = params.get(),
            getPreMadeCharactersUseCase = get(),
            createPreMadeCharacterUseCase = get(),
            updatePreMadeCharacterUseCase = get(),
            deletePreMadeCharacterUseCase = get(),
            uploadPreMadeCharacterImageUseCase = get(),
            deletePreMadeCharacterImageUseCase = get(),
            uploadPreMadeInventoryItemImageUseCase = get(),
            getGmInventoryItemsUseCase = get(),
            imageStorageRepository = get()
        )
    }
    viewModel { params ->
        SoundPlayerViewModel(
            soundRepository = get(),
            audioPlayer = get(),
            universeId = params.get(),
            uploadSoundUseCase = get(),
            deleteSoundUseCase = get(),
            getUserSoundsUseCase = get(),
            currentUserId = params.get(),
            errorNotifier = get()
        )
    }
    viewModel { params ->
        GameMasterViewModel(
            tableId = params.get(),
            currentUserId = params.get(),
            availableDice = params.get(),
            createAnnouncementUseCase = get(),
            cancelAnnouncementUseCase = get(),
            createDiceRollEventUseCase = get(),
            getTableEventsUseCase = get(),
            observeTableEventsUseCase = get(),
            sendMessageUseCase = get(),
            kickPlayerUseCase = get(),
            deleteGameTableUseCase = get(),
            updateGameTableNameUseCase = get(),
            sendGmAlertUseCase = get(),
            observeRealtimeReconnectionsUseCase = get(),
            userPreferencesDataStore = get(),
            errorNotifier = get()
        )
    }
    viewModel { params ->
        InventoryViewModel(
            characterId = params.get(),
            tableId = params.get(),
            currentUserId = params.get(),
            observeInventoryItemsUseCase = get(),
            getInventoryItemsUseCase = get(),
            createInventoryItemUseCase = get(),
            deleteInventoryItemUseCase = get(),
            updateInventoryItemQuantityUseCase = get(),
            uploadInventoryItemImageUseCase = get(),
            deleteInventoryItemImageUseCase = get(),
            transferInventoryItemUseCase = get(),
            notifyItemSentUseCase = get(),
            imageStorageRepository = get(),
            errorNotifier = get()
        )
    }
    viewModel { params ->
        GmPlayerSheetViewModel(
            characterId = params.get(),
            tableId = params.get(),
            gmUserId = params.get(),
            getCharacterByIdUseCase = get(),
            updateCharacterSheetUseCase = get(),
            touchMemberCharacterUseCase = get(),
            errorNotifier = get()
        )
    }
    viewModel { params ->
        PlayerViewModel(
            tableId = params.get(),
            currentUserId = params.get(),
            availableDice = params.get(),
            createDiceRollEventUseCase = get(),
            getTableEventsUseCase = get(),
            observeTableEventsUseCase = get(),
            sendMessageUseCase = get(),
            sendPlayerAlertUseCase = get(),
            leaveTableUseCase = get(),
            observeRealtimeReconnectionsUseCase = get(),
            audioPlayer = get(),
            userPreferencesDataStore = get(),
            errorNotifier = get()
        )
    }
}
